import * as React from 'react';

import * as s from './Loader.scss';

export const Loader = () => <div className={s.loader} />;
